module.exports = __webpack_public_path__ + "img/header-top.b866cbbe.png";